module.exports = __webpack_public_path__ + "img/indicador_agua_hover.6d699ca5.png";